import createClient from "openapi-fetch";
import { authMiddleware } from "../middleware/auth";
import { sessionMiddleware } from "../middleware/session";
import type { paths } from "./schema.d.ts";

export type PublicClient = ReturnType<typeof createPublicClient>;

export function createPublicClient(config: {
  baseUrl: string;
  headers?: Record<string, string>;
  credentials?: RequestCredentials;
}) {
  const client = createClient<paths>(config);
  client.use(sessionMiddleware);
  return client;
}

/** Public platform client that attaches Bearer + partner headers from credentials storage. */
export function createAuthenticatedPublicClient(config: {
  baseUrl: string;
  headers?: Record<string, string>;
}) {
  const client = createClient<paths>(config);
  client.use(authMiddleware);
  client.use(sessionMiddleware);
  return client;
}
